<template>
<div>

  <el-form-item label="省市县:"  class="shengSX" prop="mapShengShiQu">
       <el-input  placeholder=""   v-model="addFrom.mapShengShiQu" :readonly="true"></el-input>
  </el-form-item>
  <el-form-item label="详细地址:"  class="bigInp" prop="address">
       <el-input  placeholder="" maxlength="10"  v-model="addFrom.address" :readonly="true"></el-input>
  </el-form-item>
  <div class="mapBox">
    <div id="container"></div>
    <div  class="search-box" id="myPageTop">
      <div class="search-box-wrapper">
        <input id="tipinput" type="text" autocomplete="off" > <span class="search-btn" @click="sousuoFN">搜索</span>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import AMap from 'AMap'
export default {
  name: 'mapAddress',
  props: {
    addFrom: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      // 地图
      mapMark: false,
      markers: null,
      mapCenter: [116.397428, 39.90923],
      placeSearch: null,
      map: null

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    let that = this
    // 地图加载
    this.map = new AMap.Map('container', {
      resizeEnable: true
    })
    // 输入提示
    var autoOptions = {
      input: 'tipinput'
    }
    var auto = new AMap.Autocomplete(autoOptions)
    this.placeSearch = new AMap.PlaceSearch({
      map: that.map,
      extensions: 'all',
      pageSize: 1

    })
    // 选中时触发
    AMap.event.addListener(auto, 'select', function (e) {
      if (that.marker) {
        that.marker.setMap(null)
      }
      that.placeSearch.setCity(e.poi.adcode)
      that.placeSearch.search(e.poi.name, function (status, result) {
        that.getAddre(status, result, that)
      })
    })

    this.map.on('click', function (e) {
      that.map.clearMap()
      let { lng, lat } = e.lnglat
      that.addFrom.longitude = lng
      that.addFrom.latitude = lat
      that.marker = new AMap.Marker({
        position: [lng, lat] // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      })
      that.map.add(that.marker)
      var geocoder = new AMap.Geocoder({
        radius: 500,
        extensions: 'all'
      })
      geocoder.getAddress([lng, lat], function (status, result) {
        console.log(result)
        if (status === 'complete') {
          that.$set(that.addFrom, 'longitude', lng)
          that.$set(that.addFrom, 'latitude', lat)
          that.mapSheng = result.regeocode.addressComponent.province // 省
          that.mapShi = result.regeocode.addressComponent.city // 市
          if (that.mapShi == '') {
            that.mapShi = that.mapSheng
          }
          that.mapQu = result.regeocode.addressComponent.district // 区
          that.mapJieDao = result.regeocode.addressComponent.township // 街道
          that.mapLu = result.regeocode.addressComponent.street // 路
          that.mapHao = result.regeocode.addressComponent.streetNumber // 门牌号
          that.mapXiaoQu = result.regeocode.addressComponent.neighborhood // 小区
          that.building = result.regeocode.addressComponent.building // 建筑物
          if (that.mapXiaoQu == '') {
            that.addFrom.address = that.mapJieDao + that.mapLu + that.mapHao + that.building
          } else {
            that.addFrom.address = that.mapJieDao + that.mapLu + that.mapXiaoQu + that.building
          }
          if (that.mapQu == '') {
            that.$set(that.addFrom, 'mapShengShiQu', that.mapSheng + '-' + that.mapShi)
          } else {
            that.$set(that.addFrom, 'mapShengShiQu', that.mapSheng + '-' + that.mapShi + '-' + that.mapQu)
          }
          that.$set(that.addFrom, 'detailAddress', that.mapSheng + that.mapShi + that.mapQu + that.addFrom.address)
          that.$set(that.addFrom, 'provinceName', that.mapSheng)
          that.$set(that.addFrom, 'cityName', that.mapShi)
          that.$set(that.addFrom, 'areaName', that.mapQu)
        } else if (status == 'no_data') {
          this.$alert('没有查到相应地址', '系统提示')
        } else {
          this.$message.error('请输入正确地址')
        }
      })
    })
    // AMap.event.addListener(this.placeSearch, 'markerClick', function (e) {
    //   console.log(e)
    //   e.marker.setDraggable(true)
    // })

    if (this.addFrom.provinceName) {
      this.$set(this.addFrom, 'mapShengShiQu', this.addFrom.provinceName + '-' + this.addFrom.cityName + '-' + this.addFrom.areaName)
      if (this.addFrom.longitude && this.addFrom.latitude) {
        let marker = new AMap.Marker({
          position: [this.addFrom.longitude, this.addFrom.latitude] // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        })
        that.map.add(marker)
        that.map.setFitView()
      }
    }
  },
  methods: {
    sousuoFN () {
      var that = this
      let keyword = document.getElementById('tipinput').value
      if (that.marker) {
        that.marker.setMap(null)
      }
      this.placeSearch.search(keyword, function (status, result) {
        that.getAddre(status, result, that)
      })
    },
    // 获取地址
    getAddre (status, result, self) {
      if (status === 'complete' && result.info === 'OK') {
        let json = result.poiList.pois[0]
        self.$set(self.addFrom, 'longitude', json.location.lng)
        self.$set(self.addFrom, 'latitude', json.location.lat)
        self.$set(self.addFrom, 'mapShengShiQu', json.pname + '-' + json.cityname + '-' + json.adname)
        if (json.type == '交通设施服务;公交车站;公交车站相关') { // 公交站时不显示详细地址
          self.$set(self.addFrom, 'address', json.name)
        } else {
          self.$set(self.addFrom, 'address', json.address)
        }
        self.$set(self.addFrom, 'detailAddress', json.pname + json.cityname + json.adname + self.addFrom.address)
        self.$set(self.addFrom, 'provinceName', json.pname)
        self.$set(self.addFrom, 'cityName', json.cityname)
        self.$set(self.addFrom, 'areaName', json.adname)
      } else if (status == 'no_data') {
        this.$alert('没有查到相应地址', '系统提示')
      } else {
        this.$message.error('请输入正确地址')
      }
    }
  }

}
</script>
<style scoped lang='less'>
/deep/.shengSX .el-input__inner {
    width: 220px;
}
/deep/ .bigInp .el-input__inner {
    width: 350px;
}
#container{
  height: 500px;
}
.mapBox{
position: relative;
}
.search-box {
    width:210px;
    height: 28px;
    border:solid 1px #ccc;
    position: absolute;
    top: 5px;
    left: 5px;
    background: #fff;
}
.search-box-wrapper {
    position: absolute;
    display: flex;
    align-items: center;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}
.search-box-wrapper input {
    flex: 1;
    height: 20px;
    line-height: 20px;
    letter-spacing: .5px;
    font-size: 14px;
    text-indent: 10px;
    box-sizing: border-box;
    border: none;
    outline: none;
}
.search-box-wrapper .search-btn {
    width: 45px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    cursor: pointer;
}
</style>
